import { useEffect, useState } from 'react';
import { ReactComponent as StarFilledIcon } from '../../../assets/star-filled.svg';
import { ReactComponent as StarEmptyIcon } from '../../../assets/star-empty.svg';
import './rating-select.css';
import * as cn from 'classnames';
import { useFilter } from '../../../contexts/filter-context';

export const RatingSelect = ({ onStarsSelect }) => {
  const [minStars, setMinStars] = useState('');
  const [minStarsHover, setMinStarsHover] = useState(null);
  const state = useFilter();

  useEffect(() => {
    if (state && state.stars !== minStars) {
      setMinStars(state.stars);
    }
  }, [state]);

  const handleHover = (starNum) => {
    setMinStarsHover(starNum);
  };

  const handleClick = (starNum) => {
    if (minStars === starNum) {
      setMinStars(0);
    } else {
      setMinStars(starNum);
    }
    onStarsSelect?.(minStars === starNum ? '' : starNum);
  };

  return (
    <div className="rating-select-container" onMouseOut={() => handleHover(null)}>
      {[1, 2, 3, 4].map((starNum) => (
        <div
          key={starNum}
          className={cn(['star', minStarsHover !== null && starNum > minStarsHover && starNum <= minStars ? 'fade' : ''])}
          onMouseOver={() => handleHover(starNum)}
          onClick={() => handleClick(starNum)}
        >
          {minStars < starNum && minStarsHover < starNum ? <StarEmptyIcon width="24" height="24" /> : <StarFilledIcon width="24" height="24" />}
        </div>
      ))}
    </div>
  );
};
